import { useFormContext } from "react-hook-form";
import MultiSelect from "../../../UI/MultiSelect";
import NotImplementedWrap from "../../../UniversalEditModal/components/NotImplementedWrap";
export default function UserAchievementsSelect() {
    const { watch, setValue, getValues } = useFormContext();
    // const achievements = watch("achievements");

    return (
        <NotImplementedWrap>
            <MultiSelect
                className="universaleditmodal-multiselect"
                title="Достижения"
                setValue={setValue}
                name="asd"
                getValues={getValues}
                watch={watch}
                hasSearch={false}
                items={[]}
                classes={{
                    select_wrapper: "universaleditmodal-right-content-region",
                    select_option:
                        "universaleditmodal-right-content-region-option",
                    select_placeholder:
                        "universaleditmodal-right-content-region-placeholder",
                }}
            ></MultiSelect>
        </NotImplementedWrap>
    );
}
